// extracted by mini-css-extract-plugin
export default {"customTableData":"dragDropTable_customTableData__NQrDs","customTableRow":"dragDropTable_customTableRow__Kjhz0","customTableRowSelected":"dragDropTable_customTableRowSelected__EqFRR"};